<template>
  <div class="team-list">
    <div class="title">
      <span class="left">参赛报名</span>
    </div>
    <div class="teams">
      <div class="item" v-for="(item, index) in teamList" :key="index">
        <div class="left" style="width: 88%;">
          <div class="img">
            <van-image v-if="item.badge" :src="imgView(item.badge)" width="40px" height="40px"></van-image>
            <van-image v-else src="https://images.snsports.cn//Fg7cGro9B75lwuCLBRTIatR36obZ" width="40px" height="40px"></van-image>
          </div>
          <span v-if="item.name" class="name">{{item.name}}</span>
          <span v-else class="placeholder">请输入球队、组合或名称</span>
        </div>
        <div class="right">
          + 关注
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QNImageUtil } from "@/utils"
import {getBMMatchTeamList} from "@/api/match";
export default {
  name: "TeamList",
  props: {
    matchId: {}
  },
  data() {
    return {
      showUpdate: false,
      teamList: []
    }
  },
  mounted() {
    this.getBMMatchTeamList()
  },
  methods: {
    imgView(img) {
      return QNImageUtil.imageView(img)
    },
    getBMMatchTeamList() {
      const params = {
        matchId: this.matchId
      }
      getBMMatchTeamList(params).then(res => {
        if (res) {
          const { data } = res
          this.teamList = (data.groups[0] && data.groups[0].teams) || []
        }
      })
    }
  }
}
</script>

<style lang="scss">
.team-list {
  background-color: #ffffff;
  width: 100%;
  border-radius: 8px;
  padding-bottom: 16px;
  box-sizing: border-box;
  .title {
    font-weight: 500;
    padding: 0;
    box-sizing: border-box;
    height: 51px;
    margin: 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: #E5E5E5 0.5px solid;
    .left {
      font-size: 14px;
      color: #191919;
    }
    .right {
      width: 52px;
      display: flex;
      justify-content: space-between;
      color: #8C8C8C;
    }
  }
  .teams {
    .item {
      width: 319px;
      height: 64px;
      padding: 0 12px;
      box-sizing: border-box;
      margin: 9px auto;
      background-color: #F9FAFC;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        display: flex;
        flex-flow: row;
        align-items: center;
        .img {
          border-radius: 8px;
          overflow: hidden;
        }
        .name {
          font-weight: 500;
          font-size: 14px;
          color: #191919;
          margin-left: 12px;
        }
        .placeholder {
          font-size: 14px;
          color: #B9B9B9;
          margin-left: 12px;
        }
      }
      .right {
        width: 44px;
        height: 20px;
        border-radius: 2px;
        background-color: #E7F1FF;
        color: #409EFF;
        font-size: 12px;
        line-height: 20px;
        text-align: center;
      }
    }
  }
  .team-name {
    padding: 24px 12px 0 12px;
    box-sizing: border-box;
    display: flex;
    flex-flow: row;
    align-items: center;
    .label {
      padding-right: 12px;
      box-sizing: border-box;
      font-size: 14px;
      color: #191919;
    }
    .mine {
      padding-top: 18px;
      box-sizing: border-box;
      border-radius: 4px;
      background-color: #FAFBFD;
      .img {
        width: 44px;
        height: 44px;
        margin: 0 auto;
      }
      .info {
        text-align: center;
        color: #BABBC5;
        font-size: 14px;
      }
    }
  }
  .bottom {
    height: 100px;
    width: 100vw;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 10px 10px 0 0;
    background-color: #ffffff;
    padding: 16px 12px 0 12px;
    box-sizing: border-box;
    .button {
      width: 100%;
      height: 50px;
      border-radius: 25px;
      background-color: #191919;
      color: #FFFFFF;
      font-size: 16px;
      line-height: 50px;
      text-align: center;
    }
  }
}
</style>
